// Motivos válidos cuando no se puede registrar una calificación (0 a 5 estrellas).
// Los códigos deben coincidir con CONSTANTS.SURVEY.NO_RATING_REASONS en el backend.
export const SurveyReasons = [
  { value: 'THIRD_PARTY', text: 'Recibió un tercero' },
  { value: 'CLIENT_REFUSED', text: 'Cliente no quiso calificar' },
  { value: 'CLIENT_UNAVAILABLE', text: 'Cliente no estaba disponible' }
]
